<app-navbar-style-one></app-navbar-style-one>

<div class="menu-page account-section">
    <div class="container-fluid">
        <div class="content-wrapper">
            <!-- Left Image -->
            <div class="left-image">
                <img src="../../../assets/img/home2/header1.jpg" alt="Chef seasoning steak">
            </div>

            <!-- Center Content -->
            <div class="center-content">
                <h2>{{ 'Terms & Conditions' | titlecase}}</h2>
                <p>
                    Welcome to ROMA Terms & Conditions
                    Welcome to ROMA. By accessing or using our website, ordering online, or visiting our physical location, you agree to the following terms and conditions. Please read them carefully.
                </p>
            </div>

            <!-- Right Images -->
            <div class="right-images">
                <img src="../../../assets/img/home2/header3.jpg" alt="Stuffed mushroom dish">
                <img src="../../../assets/img/home2/header2.jpg" alt="Gourmet burger with fries">
            </div>
        </div>
    </div>
</div>

<div class="terms-conditions-area ptb-100">
    <div class="container">
        <div class="single-content">
            <h3>Welcome to Roma Pizza Terms & Conditions</h3>
            <div class="terms-content" [innerHTML]="settings"></div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>